
<!-- Template -->
<template>
    <div class="modal fade" id="create-thread" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
        <div class="modal-dialog" role="document">
        <div class="modal-content" style="border-radius: 0px;">
            <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
            <h4 class="modal-title" id="myModalLabel">START A DISCUSSION</h4>
            </div>
            <div class="modal-body" v-if="!loggedIn">
                <div style="padding:2em;">
                    <p style="color:#9c0909; font-size:18px; line-height:1.6;">It will only take just few minutes, Log in / Create your cityneeds account to start a discussion</p>
                    <button type="button" class="btn btn-primary btn-xl" @click="setReg">
                        Log In / Create <br> your cityneeds account
                    </button>
                </div>
            </div>
            <div v-else class="modal-body">
                <form>
                    <div class="form-group">
                        <label>Discussion Title</label>
                        <input v-model="thread.forum_topic" type="text" class="form-control" placeholder="Discussion Title">
                    </div>
                    <div class="form-group">
                        <label>Category</label>
                        <!-- <select v-model="thread.forum_category" class="form-control" @change="getUserCat(thread.forum_category)"> -->
                        <select v-model="thread.forum_category" class="form-control">
                            <option value="1">CNpro</option>
                            <option value="2">Business</option>
                            <option value="6">Community</option>
                        </select>
                    </div>
                    <!-- <div class="form-group" v-if="businesses.length > 0">
                        <label>Business</label>
                        <select class="form-control" v-model="thread.business">
                            <option :v-repeat="bus in businesses">{{bus.bu_name}}</option>
                        </select>
                    </div> -->
                    <div class="form-group">
                        <label>Short Description</label>
                        <textarea v-model="thread.forum_description" class="form-control" rows="3" placeholder="What would you want to discuss?"></textarea>
                    </div>
                    <div class="form-group">
                        <label> Add a Photo?</label>
                        <input type="file" id="input-file" @change="onFileChange($event)" accept="image/*"/>
                    </div>
                </form>
            </div>
            <div class="modal-footer" v-if="loggedIn">
                <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
                <button type="button" class="btn btn-primary" data-dismiss="modal" @click="createThread">Submit</button>
            </div>
        </div>
        </div>
    </div>
</template>

<!-- Script -->
<script>
import services from '../services/service'; // Service Class
import utilities from '../services/utility';
let service = new services();
let utility = new utilities();

export default {
  name: "CreateThread",
  data() {
      return {
          user: {},
          thread: {},
          pro: [],
          businesses: [],
          imageForm: {},
          set_image: false,
          loggedIn: false,
      }
  },
  methods: {
    // Creating a thread
     preset() {
            var credentials = {
                session_key: localStorage.getItem("cityneeds_token")
            } 
           if(credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(response => {
                    if(response.body.status == 200) {
                        let data = response.body.data;
                        data.forEach(function(element) {
                            this.user.user_id = element.user_id;
                            this.loggedIn = true;
                        }, this);
                        }else {
                            this.$router.push('login');
                      }
                }).catch((err) => {
                    if(err) {
                     this.$router.push('login');
                    }
                })
            }else {
                this.$router.push('login');
            }
            
    },

    createThreadXX() {
        localStorage.setItem("cn_prv_page","forums");//log current page
        this.preset();
        let data = this.thread;
        data.forum_business = 0;
        data.forum_cnpro = 0;
        //data.forum_created_by = utility.getUserId();
        data.forum_created_by = this.user.user_id;
        service.postThread(this, data).then((response) => {
            if(response.body.status = 201) {
                toastr.success("Thread created", 'Ok buddy'); 
                window.location.reload();
            }else {
                toastr.warning("Couldn't complete action, kindly try again", 'Warning!'); 
            }
        })
    },

    createThread() {
        localStorage.setItem("cn_prv_page","forums");//log current page
        this.preset();
        let data = this.thread;
        data.forum_business = 0;
        data.forum_cnpro = 0;
        //data.forum_created_by = utility.getUserId();
        data.forum_created_by = this.user.user_id;
        service.postThread(this, data).then((response) => {
            if(response.body.status = 201) {
                this.thread = {}; //empty
                toastr.success("Thread created", 'Ok buddy'); 
                //window.location.reload();
                //add image
                if(this.set_image){
                    let forum_id = response.body.data;
                    this.imageForm.append("data_id", forum_id);
                    this.imageForm.append("data_type","forum_attachment");
                    service.uploadDataPhoto(this, this.imageForm).then(data => {
                        location.reload();
                        }).catch((err) => {
                        if(err) {
                            // log it
                        }
                    })
                }else{
                    location.reload();
                }
                
                
            }else {
                toastr.warning("Couldn't complete action, kindly try again", 'Warning!'); 
            }
        })
    },

    // Getting user's business or pro profiles base on choice   
    getUserCat(choice) {
        let token = utility.getUserToken();
        //console.log("oop",token)
        if(choice == 1) {
            service.getUserPros(this, token).then((res) => {
                this.pro = res.body.data;
            })
        }else if(choice == 2) {
            service.getBusinesses(this, token).then((res) => {
                // this.businesses = res.body.data;
                console.log(res.body.data)
            })
        }
    },

    //uploads
    onFileChange(e) {
        let files = e.target.files || e.dataTransfer.files;
        if (files.length)
        {
            let formData = new FormData();
            formData.append('photo', files[0]); 
            this.imageForm = formData;
            this.set_image = true;
        }   
            
    },
    //
    setReg(){
        localStorage.setItem("current_page",'forums');
        location.replace('login');
    },

  },
  created: function(){
     // this.preset();
    let u_t = localStorage.getItem("cityneeds_token");
    if((u_t != null)) {
        this.preset();
    }
  }
}
</script>




// WEBPACK FOOTER //
// CreateThread.vue?eacd49a8